import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { generalResponse, GeneralParams } from 'interfaces/general.interface'
import {  DataParams, DataParamsSender } from 'interfaces/assigned.interface'
const api_base = "/connect";



export const UIListService = createApi({
    reducerPath: "UIListService",
    refetchOnFocus: false,
    baseQuery: fetchBaseQuery({
        baseUrl: `${api_base}`,
        prepareHeaders: (headers) => {
            headers.set('Content-Type', 'application/json');
            headers.set('Accept', 'application/xml');
            return headers;
        },
        credentials: "include",

    }),
    tagTypes: ['UIList'],
    endpoints: (builder) => ({
        getListXML: builder.query<any, DataParams>({
            query: (params) => ({
                url: `/vzuilist/${params.projectID}/GetListXML?FieldID=${params.fieldID}&Query=${params.query}&Sort=${params.sort}&Layout=${params.layout}&DtsRecordID=${params.dtsRecordID}`,
                method: "GET",
                responseHandler: (response) => response.text(),
                transformResponse: (response: string) => {
                    const parser = new DOMParser();
                    const xml = parser.parseFromString(response, 'application/xml');
                    return xml;
                },
            })
        }),

        getListSimpleUIList: builder.query<any, any>({
            
            query: (params) => ({
                url: `/vzuilist/15/GetListXML`,
                method: "POST",
                body: JSON.stringify(params),
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/xml',
                },            
                responseHandler: (response) => response.text(),
                transformResponse: (response: string) => {
                    const parser = new DOMParser();
                    const xml = parser.parseFromString(response, 'application/xml');
                    return xml;
                },

                
            })
        }),


        getListXMLExample: builder.query<any, DataParams>({
            query: (params) => ({
                url:"http://localhost:3000/data/exampleListXML.xml", 
                method: "GET",
                responseHandler: (response) => response.text(),
                transformResponse: (response: string) => {
                    const parser = new DOMParser();
                    const xml = parser.parseFromString(response, 'application/xml');
                    return xml;
                },
            })
        }),
    }),
});

export const {
    useGetListXMLQuery,
    useGetListXMLExampleQuery,
    useGetListSimpleUIListQuery
} = UIListService;
